import React, { FC, useMemo } from "react";
import { useIntl } from "react-intl";
import { buildLookupScheduleUrl } from "./helpers";
import { messages } from "./messages";
import { PublicGisMatchedOrder } from "./types";

interface ScheduleViewProps {
  matchedOrder: PublicGisMatchedOrder;
  /** Returns to the screen that sent the visitor here. */
  onBack: () => void;
}

/**
 * Renders the Acuity scheduling iframe for the matched order. The iframe URL is
 * built with `schedulingSourceValue = Public_Entry_Order_Lookup` and the
 * order's pre/post-test counseling intent (derived from `status`), so funnel
 * attribution and counseling intent flow into Acuity for both WH/OH and ONC
 * calendars (the owner/appointment-type differ per test type via
 * `buildAcuityGisIframeUrl`).
 */
const ScheduleView: FC<ScheduleViewProps> = ({ matchedOrder, onBack }) => {
  const intl = useIntl();

  const iframeUrl = useMemo(
    () => buildLookupScheduleUrl(matchedOrder),
    [matchedOrder]
  );

  return (
    <div className="public-gis-lookup__schedule">
      <h1 className="public-gis-lookup__schedule-title">
        {intl.formatMessage(messages.scheduleTitle)}
      </h1>
      <iframe
        className="public-gis-lookup__schedule-iframe"
        title={intl.formatMessage(messages.scheduleTitle)}
        src={iframeUrl}
        width="100%"
        height="800"
        frameBorder="0"
      />
      {/* Below the scheduler, where a visitor who scrolled through it ends up. */}
      <div className="public-gis-lookup__schedule-actions">
        <button
          type="button"
          className="public-gis-lookup__schedule-back"
          onClick={onBack}
        >
          {intl.formatMessage(messages.back)}
        </button>
      </div>
    </div>
  );
};

export default ScheduleView;
